import { DocumentPreviewSkeleton } from "@/components/DocumentPreviewSkeleton";

import { type TextViewerViewProps } from "./types";

export function TextViewerView({
  fileName,
  isLoading,
  hasLoadError,
  isTruncated,
  text,
}: TextViewerViewProps) {
  if (isLoading) {
    return <DocumentPreviewSkeleton variant="content" />;
  }

  if (hasLoadError) {
    return (
      <div className="flex h-full items-center justify-center p-4 text-center text-sm text-muted-foreground">
        Couldn&apos;t preview this file
      </div>
    );
  }

  return (
    <div className="flex h-full w-full flex-col">
      {isTruncated && (
        <p className="px-4 pt-4 text-xs text-muted-foreground">
          Showing the start of this file — download it to view the rest.
        </p>
      )}
      <pre
        role="document"
        aria-label={fileName}
        className="min-h-0 w-full flex-1 overflow-auto whitespace-pre-wrap break-words p-4 font-mono text-xs text-foreground"
      >
        {text}
      </pre>
    </div>
  );
}
